import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { ref, computed, PropType } from "vue";
import { authStore } from "@/store/auth";
import Precautions from "@/components/organisms/orders/ApplicationReminderModal/Precautions.vue";
import HowToCancel from "@/components/organisms/orders/ApplicationReminderModal/HowToCancel.vue";
import ApplicationConfirmation from "@/components/organisms/orders/ApplicationReminderModal/ApplicationConfirmation.vue";
import { Application } from "@/types/order/Application";
import { useCustomRouter } from "@/utils/router";

type PageType = "Precautions" | "HowToCancel" | "ApplicationConfirmation";


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationReminderModal',
  props: {
  applicationToRemind: {
    type: Object as PropType<Application>,
    required: true
  }
},
  emits: ["close-hook"],
  setup(__props, { emit }) {

const props = __props;


const isShown = computed(() => !!props.applicationToRemind);
const user = computed(() => authStore.user!); // このモーダルはログイン済みユーザーにしか表示しない想定
const page = ref<PageType>("Precautions");

const { pushIgnoreError } = useCustomRouter();

/**
 * モーダル内のキャンセル方法ページへ進む
 */
const proceedCancel = () => {
  page.value = "HowToCancel";
};

/**
 * モーダル内の応募確認ページへ進む
 */
const proceedApply = () => {
  page.value = "ApplicationConfirmation";
};

/**
 * モーダル内のページを戻る
 */
const back = () => {
  page.value = "Precautions";
};

const isPagePrecautions = computed(() => page.value === "Precautions");
const isPageHowToCancel = computed(() => page.value === "HowToCancel");
const isPageApplicationConfirmation = computed(
  () => page.value === "ApplicationConfirmation"
);

/**
 * 応募のキャンセル画面へ進む
 */
const cancelApplication = () => {
  emit("close-hook", "cancel");
  pushIgnoreError({
    name: "OrdersCancelPolicyDisplay",
    query: {
      applicationId: String(props.applicationToRemind!.id)
    }
  });
};

/**
 * 応募を確定する
 */
const confirmApplication = () => {
  emit("close-hook", "confirm");
};

return (_ctx: any,_cache: any) => {
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    visible: isShown.value,
    "no-fade": "",
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    "hide-header-close": "",
    centered: "",
    "hide-header": "",
    "body-class": "modal-body",
    "hide-footer": ""
  }, {
    default: _withCtx(() => [
      (isPagePrecautions.value)
        ? (_openBlock(), _createBlock(Precautions, {
            key: 0,
            user: user.value,
            applicationToRemind: __props.applicationToRemind,
            onCancel: proceedCancel,
            onApply: proceedApply
          }, null, 8, ["user", "applicationToRemind"]))
        : (isPageHowToCancel.value)
          ? (_openBlock(), _createBlock(HowToCancel, {
              key: 1,
              onCancel: cancelApplication,
              onBack: back
            }))
          : (isPageApplicationConfirmation.value)
            ? (_openBlock(), _createBlock(ApplicationConfirmation, {
                key: 2,
                onConfirm: confirmApplication,
                onBack: back,
                workerLastName: user.value.lastName
              }, null, 8, ["workerLastName"]))
            : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }, 8, ["visible"]))
}
}

})